// src/app/core/responsive.service.ts
import { Injectable, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  private bo = inject(BreakpointObserver);

  /** true on narrow phones (portrait handset) */
  readonly isHandset$ = this.bo
    .observe([Breakpoints.HandsetPortrait, Breakpoints.Handset])
    .pipe(map(r => r.matches), shareReplay({ bufferSize: 1, refCount: true }));
}
